import React from "react";
import {
  Box,
  Grid,
  TextField,
  IconButton,
  InputLabel,
  Typography,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DOMPurify from "dompurify";
import AddImageComponent from "./AddImageComponent";
import WysiwygEditor from "../MarkdownEditor/WysiwygEditor";

const StepsEditor = ({
  steps,
  mode,
  onStepChange,
  onDeleteStep,
  onAddStep,
  onStepImageChange,
  onStepImageDelete,
  errors = [],
}) => (
  <>
    {(mode !== "view" || (mode === "view" && steps.length > 0)) && (
      <Box sx={{ mt: 3 }}>
        {steps.map((step, index) => (
          <Box key={index} sx={{ mt: 3 }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={5} sx={{ textAlign: "right" }}>
                <InputLabel>Step {index + 1} name</InputLabel>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  value={step.title}
                  onChange={(e) => onStepChange(index, "title", e.target.value)}
                  error={Boolean(errors?.[index]?.title)}
                  helperText={errors?.[index]?.title}
                  InputProps={{ readOnly: mode === "view" }}
                  inputProps={{ maxLength: 100 }}
                  sx={{
                    "& .MuiOutlinedInput-root": { backgroundColor: "white" },
                  }}
                />
              </Grid>
              <Grid item xs={1}>
                {mode !== "view" && (
                  <IconButton onClick={() => onDeleteStep(index)}>
                    <DeleteIcon />
                  </IconButton>
                )}
              </Grid>
            </Grid>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={5} sx={{ textAlign: "right" }}>
                <InputLabel>Step {index + 1} description</InputLabel>
              </Grid>
              <Grid item xs={6}>
                {mode === "view" ? (
                  <div
                    className="wysiwyg-content"
                    style={{
                      backgroundColor: "white",
                      padding: "16px",
                      borderRadius: "4px",
                      border: "1px solid rgba(0, 0, 0, 0.23)",
                      marginTop: "16px",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(step.content || ""),
                    }}
                  />
                ) : (
                  <Box sx={{ mt: 2 }}>
                    <WysiwygEditor
                      value={step.content || ""}
                      onChange={(text, html) => onStepChange(index, "content", html)}
                      placeholder="Help your client understand why this step is important."
                    />
                  </Box>
                )}
              </Grid>
            </Grid>
            <Box sx={{ paddingLeft: 0.5, paddingTop: 2 }}>
              <AddImageComponent
                inputName={`steps[${index}][step_image]`}
                fileName={step.step_image}
                onImageChange={(file) => onStepImageChange(index, file)}
                onImageDelete={() => onStepImageDelete(index)}
              />
              {(mode !== "view" || (mode === "view" && step.image)) && (
                <Box sx={{ mt: 2 }}>
                  {step.image && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box
                        sx={{
                          bgcolor: "#C5C5A4",
                          p: 1,
                          borderRadius: 1,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {step.image.name}
                      </Box>
                      {mode !== "view" && (
                        <IconButton onClick={() => onStepImageDelete(index)}>
                          <DeleteIcon />
                        </IconButton>
                      )}
                    </Box>
                  )}
                </Box>
              )}
            </Box>
          </Box>
        ))}
      </Box>
    )}
    <Button
      variant="text"
      onClick={onAddStep}
      sx={{ ml: steps.length === 0 ? 5 : 2 }}
    >
      <Typography textTransform={"none"}>
        {steps.length === 0 ? "Add instructions" : "Add next step"}
      </Typography>
    </Button>
  </>
);

export default StepsEditor;
